import React, { useCallback } from "react";
import { connect } from "react-redux";
import TabPanel, { Item as TabPanelItem } from "devextreme-react/tab-panel";
import routes from "../../../assets/apiRoutes.json"
import axios from "axios";
import { GridLayout } from "../../../common/GridLayout";
import { handleDataGridExport } from "../../../common/Utils";
import { createStore } from 'devextreme-aspnet-data-nojquery';
import { Button } from 'devextreme-react/button';
import SelectBox from 'devextreme-react/select-box';
import { alert } from 'devextreme/ui/dialog';
import { confirm } from 'devextreme/ui/dialog';
import { Popup } from 'devextreme-react/popup';
import Accordion from 'devextreme-react/accordion';
import TextBox from 'devextreme-react/text-box';
import notify from 'devextreme/ui/notify';
import { LoadPanel as DivLoadPanel } from 'devextreme-react/load-panel';
import { ABECASUSER_LOGIN_TYPE } from "../../../common/permissions";
import ToolbarHdr, { Item as ItemHdr } from "devextreme-react/toolbar";
import {
  Validator,
  RequiredRule,
  EmailRule,
  PatternRule,
  AsyncRule,
} from 'devextreme-react/validator';
import {
  Column,
  DataGrid,
  GroupPanel,
  Grouping,
  FilterRow,
  FilterPanel,
  Sorting,
  Paging,
  Pager,
  LoadPanel,
  Export,
  ColumnHeaderFilter,
  ColumnChooser,
  ColumnChooserSearch,
  Selection,
  HeaderFilter,
  Editing,
  ColumnFixing,
  StateStoring,
  Toolbar,
  Item,
  Summary, TotalItem
} from "devextreme-react/data-grid";
import GridLayoutManager from "../../../gridLayoutCustomization/GridLayoutManager";
import DataSource from "devextreme/data/data_source";

let accessToken = '';
let isAbecasUser = false;

const searchpanel = [
  {
    ID: 1,
    Name: 'Search Filters'
  }
];

const outgoingGrid = React.createRef();
const outgoingGridKey = "ae61a600-b287-46ea-bdf1-8c0a5d256ab8";
const outgoingGridLoadState = () => { return GridLayout.sendStorageRequest(outgoingGridKey, "GET", accessToken); }

const incomingGrid = React.createRef();
const incomingGridKey = "e76fd2bc-314a-4515-abe8-92c86038a86b";
const incomingGridLoadState = () => { return GridLayout.sendStorageRequest(incomingGridKey, "GET", accessToken); }

var detailOTDataGrid = React.createRef();
const detailGridKey = "3350ea40-9344-407f-8bda-34fe38e742d8";
const detailGridLoadState = () => { return GridLayout.sendStorageRequest(detailGridKey, "GET", accessToken); }

var detailInDataGrid = React.createRef();
const detailInGridKey = "1a7ab8aa-e104-45c3-bb01-3d4d02729ec8";
const detailInGridLoadState = () => { return GridLayout.sendStorageRequest(detailInGridKey, "GET", accessToken); }

class OwnershipTransfer extends React.Component {

  constructor(props) {
    super(props);
    accessToken = props.oidc.user.access_token;
    isAbecasUser = props.oidc.user.profile.hasOwnProperty("LOGINTYPEID") && props.oidc.user.profile.LOGINTYPEID == ABECASUSER_LOGIN_TYPE;
    this.saveHeaderData = this.saveHeaderData.bind(this);
    this.ResetGridFilter = this.ResetGridFilter.bind(this);
    this.SearchGridFilter = this.SearchGridFilter.bind(this);
    this.DetailGridContentReady = this.DetailGridContentReady.bind(this);
    this.DetailInGridContentReady = this.DetailInGridContentReady.bind(this);
    this.DetailGridselectionChanged = this.DetailGridselectionChanged.bind(this);
    this.selectionChanged = this.selectionChanged.bind(this);
    this.customerValidation = this.customerValidation.bind(this);

    this.state = {
      currentLayout: "Default",
      selectedOutgoingGridKeys: [],
      selectedIncomingGridData: [],
      selectedOutgoingGridData: [],
      loadIndicatorVisible: false,
      detailTransferQuantityCount: 0,
      addEditOutgoingGridPopupVisible: false,
      outgoingGridPopupTitle: "Add Ownership Transfer Request",
      selectedItems: searchpanel,
      searchPanelStatus: true,
      outgoingGridRecordData: {
        rowid: '00000000-0000-0000-0000-000000000000',
        requestid: '',
        status: '',
        emailid: '',
        OTDetailGridData: [],
        identityid: '',
        isDisableSaveBtn: true,
        incomingcustomerrowid: '00000000-0000-0000-0000-000000000000'
      },
      OTDetailGridDataFilterCriteria: {
        Itemcodefrom: "",
        Itemcodeto: "",
        Lotcodefrom: "",
        Lotcodeto: "",
        Itemdescfrom: "",
        Itemdescto: "",
        Lotdescfrom: "",
        Lotdescto: "",
        Rtransferheaderid: '00000000-0000-0000-0000-000000000000'
      },
      selectedIncomingGridKeys: [],
      incomingGridPopupVisible: false,
      incomingGridPopupTitle: "View Ownership Transfer Request",
      incomingGridRecordData: {
        requestid: '',
        status: '',
        emailid: '',
        identityid: '',
        incomingcustomerrowid: '',
      },
      isApprovedClicked: false
    };
    this.customerEditorOptions = {
      dataSource: createStore({
        loadUrl: `${window._env_.REACT_APP_APIS}/${routes.OwnerShipTransfer.GetCustomers}`,
        onBeforeSend: function (method, ajaxOptions) {
          ajaxOptions.headers = {
            Authorization: `Bearer ${accessToken}`
          };
        }
      }),
      searchEnabled: true,
      value: '',
      displayExpr: "name",
      valueExpr: "id"
    };

    this.outgoingGridContentReady = this.outgoingGridContentReady.bind(this);
    this.outgoingGridDataSource = createStore({
      key: 'rowid',
      loadParams:
      {
        requestType: function () {
          return "outgoing";
        }
      },
      loadUrl: `${window._env_.REACT_APP_APIS}/${routes.OwnerShipTransfer.GetOwnershipTransfers}`,
      onBeforeSend: function (method, ajaxOptions) {
        ajaxOptions.headers = {
          Authorization: `Bearer ${accessToken}`
        };
      }
    });
    this.outgoingGridselectionChanged = this.outgoingGridselectionChanged.bind(this);
    this.addOutgoingTransfer = this.addOutgoingTransfer.bind(this);
    this.viewIncomingTransfer = this.viewIncomingTransfer.bind(this);
    this.editOutgoingTransfer = this.editOutgoingTransfer.bind(this);
    this.deleteOutgoingTransfer = this.deleteOutgoingTransfer.bind(this);
    this.hideAddEditOutgoingGridPopup = this.hideAddEditOutgoingGridPopup.bind(this);
    this.incomingGridselectionChanged = this.incomingGridselectionChanged.bind(this);
    this.AcceptClick = this.AcceptClick.bind(this);
    this.RejectClick = this.RejectClick.bind(this);
    this.ApprovedClick = this.ApprovedClick.bind(this);
    this.UpdateOTStatusAcceptOrReject = this.UpdateOTStatusAcceptOrReject.bind(this);
    this.hideIncomingGridPopup = this.hideIncomingGridPopup.bind(this);
    var that = this;

    this.incomingGridContentReady = this.incomingGridContentReady.bind(this);
    this.incomingGridDataSource = createStore({
      key: 'rowid',
      loadParams:
      {
        requestType: function () {
          return "incoming";
        }
      },
      loadUrl: `${window._env_.REACT_APP_APIS}/${routes.OwnerShipTransfer.GetOwnershipTransfers}`,
      onBeforeSend: function (method, ajaxOptions) {
        ajaxOptions.headers = {
          Authorization: `Bearer ${accessToken}`
        };
      }
    });

    this.DetailDataGridDataSource = createStore({
      key: 'key',
      loadParams:
      {
        Itemcodefrom: function () {
          return that.state.OTDetailGridDataFilterCriteria.Itemcodefrom;
        },
        Itemcodeto: function () {
          return that.state.OTDetailGridDataFilterCriteria.Itemcodeto;
        },
        Itemdescfrom: function () {
          return that.state.OTDetailGridDataFilterCriteria.Itemdescfrom;
        },
        Itemdescto: function () {
          return that.state.OTDetailGridDataFilterCriteria.Itemdescto;
        },
        Lotcodefrom: function () {
          return that.state.OTDetailGridDataFilterCriteria.Lotcodefrom;
        },
        Lotcodeto: function () {
          return that.state.OTDetailGridDataFilterCriteria.Lotcodeto;
        },
        Lotdescfrom: function () {
          return that.state.OTDetailGridDataFilterCriteria.Lotdescfrom;
        },
        Lotdescto: function () {
          return that.state.OTDetailGridDataFilterCriteria.Lotdescto;
        },
        Rtransferheaderid: function () {
          return that.state.outgoingGridRecordData.rowid;
        },
        Isaddoredit: function () {
          return true;
        },
      },
      loadUrl: `${window._env_.REACT_APP_APIS}/${routes.OwnerShipTransfer.LoadOwnerShipTransferDetailGrid}`,
      updateUrl: `${window._env_.REACT_APP_APIS}/${routes.OwnerShipTransfer.UpdateOwnerShipWMTransferRecords}`,
      onBeforeSend: function (method, ajaxOptions) {
        ajaxOptions.headers = {
          access_token: accessToken,
          Authorization: `Bearer ${accessToken}`,
        };
      }
    });

    this.DetailInDataGridDataSource = createStore({
      key: 'rowid',
      loadParams:
      {
        Rtransferheaderid: function () {
          return that.state.selectedIncomingGridKeys[0];
        },
        Isaddoredit: function () {
          return true;
        },
      },
      loadUrl: `${window._env_.REACT_APP_APIS}/${routes.OwnerShipTransfer.LoadOwnerShipTransferViewGrid}`,
      updateUrl: `${window._env_.REACT_APP_APIS}/${routes.OwnerShipTransfer.UpdateTransferDetails}`,
      onBeforeSend: function (method, ajaxOptions) {
        ajaxOptions.headers = {
          access_token: accessToken,
          Authorization: `Bearer ${accessToken}`,
        };
      }
    });
  }
 outgoingGridLoadState = () => { return GridLayout.sendStorageRequest(outgoingGridKey, "GET", accessToken,null, this.state.currentLayout); }
 incomingGridLoadState = () => { return GridLayout.sendStorageRequest(incomingGridKey, "GET", accessToken,null, this.state.currentLayout); }
 detailGridLoadState = () => { return GridLayout.sendStorageRequest(detailGridKey, "GET", accessToken,null, this.state.currentLayout); }
 detailInGridLoadState = () => { return GridLayout.sendStorageRequest(detailInGridKey, "GET", accessToken,null, this.state.currentLayout); }

  outgoingGridSaveState = (state) => { GridLayout.sendStorageRequest(outgoingGridKey, "POST", accessToken, state, this.state.currentLayout); }
  incomingGridSaveState = (state) => { GridLayout.sendStorageRequest(incomingGridKey, "POST", accessToken, state, this.state.currentLayout); }
  detailGridSaveState = (state) => { GridLayout.sendStorageRequest(detailGridKey, "POST", accessToken, state, this.state.currentLayout); }
  detailInGridSaveState = (state) => { GridLayout.sendStorageRequest(detailInGridKey, "POST", accessToken, state, this.state.currentLayout); }
  handleFormChange = (field, value) => {
    this.setState((prevState) => {
      return {
        outgoingGridRecordData: {
          ...prevState.outgoingGridRecordData,
          [field]: value,
        }
      };
    });
  };
  LoadItems = () => {
    var customerRowid = this.state.incomingGridRecordData.incomingcustomerrowid;
    const selectBoxData = new DataSource({
      store: createStore({
        loadUrl: `${window._env_.REACT_APP_APIS}/${routes.OwnerShipTransfer.GetItems}`,
        key: 'id',
        loadParams: {
          customerIdentity: customerRowid // Pass your custom parameter here
        },
        onBeforeSend: function (method, ajaxOptions) {
          ajaxOptions.headers = {
            Authorization: `Bearer ${accessToken}`
          };
        }
      }),
      paginate: true,
      pageSize: 100
    });
    return selectBoxData;
  };


  setCurrentLayout = (value) => {
    this.setState({
      currentLayout: value
    })
  }
  renderItemCell = (cellElement) => {
    const items = this.LoadItems()
    return (
      <SelectBox
        dataSource={items}
        valueExpr="id"
        displayExpr="name"
        searchEnabled={true}
        useNativeScrolling={false}
        pagingEnabled={true}
        pageLoadMode="scrollBottom"
        onValueChanged={(e) => {

          const selectedText = e.component.option('displayValue');
          cellElement.setValue(selectedText);
          //cellElement.row.data.itemId = e.value;
        }}
      />
    );
  }
  SearchGridFilter(e) {
    if (e?.event)
      e.event.stopPropagation();
    detailOTDataGrid.current.instance().refresh();
  }
  customerValidation(params) {
    return new Promise((resolve) => {
      axios.get(
        `${window._env_.REACT_APP_APIS}/${routes.OwnerShipTransfer.CheckCustomerExists}?identityid=${params.value}`,
        {
          headers: {
            "Content-Type": "application/json",
            access_token: accessToken,
            Authorization: `Bearer ${accessToken}`,
          },
        }).then((response) => {
          if (response.data.success) {
            resolve(true);
            this.setState((prevState) => {
              return {
                outgoingGridRecordData: {
                  ...prevState.outgoingGridRecordData,
                  isDisableSaveBtn: false,
                  identityid: response.data.resultdata.name,
                  incomingcustomerrowid: response.data.resultdata.id
                }
              };
            });
          }
          else {
            this.setState((prevState) => {
              return {
                outgoingGridRecordData: {
                  ...prevState.outgoingGridRecordData,
                  identityid: "",
                  incomingcustomerrowid: "",
                  isDisableSaveBtn: true
                }
              };
            });
            notify({
              message: 'Please enter valid customer code.',
              width: 450,
            }, 'error', 2000);
            resolve(false);
          }
        });
    });

  }
  DetailGridselectionChanged(e) {
    if (this.state.outgoingGridRecordData.rowid === "" || this.state.outgoingGridRecordData.rowid === "00000000-0000-0000-0000-000000000000") {
      notify({
        message: 'Please save header record first',
        width: 450,
      }, 'error', 2000);
      detailOTDataGrid.current.instance().cancelEditData();
      e.cancel = true;
    }
    else {
      e.newData['ritem'] = e.oldData['ritem'];
      e.newData['rlot'] = e.oldData['rlot'];
      e.newData['Rhdrid'] = this.state.outgoingGridRecordData.rowid;
      if (e.newData.hasOwnProperty('quantityorder')) {
        e.newData['isselected'] = true;
      }
      if (!e.newData.hasOwnProperty('rowid'))
        e.newData['rowid'] = e.oldData['rowid'];
    }
    let count = 0;
    this.setState(prevState => {
      if (e.newData['isselected'] == true) {
        count = prevState.detailTransferQuantityCount + (e.newData.hasOwnProperty('quantityorder') ? e.newData.quantityorder: 0);
      }
      else {
        count = prevState.detailTransferQuantityCount - e.oldData.quantityorder;
      }
      return {
        ...prevState,
        detailTransferQuantityCount: count
      }
    });
  }
  selectionChanged(e) {
    let newItems = [...this.state.selectedItems];
    e.removedItems.forEach((item) => {
      const index = newItems.indexOf(item);
      if (index >= 0) {
        newItems.splice(index, 1);
      }
    });
    if (e.addedItems.length) {
      newItems = [...newItems, ...e.addedItems];
    }
    this.setState((prevState) => ({
      selectedItems: newItems,
      searchPanelStatus: !prevState.searchPanelStatus
    }));
  }

  ResetGridFilter(e) {
    if (e != null && e != undefined) {
      e.event.stopPropagation();
      this.setState({
        OTDetailGridDataFilterCriteria: {
          Itemcodefrom: "",
          Itemcodeto: "",
          Lotcodefrom: "",
          Lotcodeto: "",
          Itemdescfrom: "",
          Itemdescto: "",
          Lotdescfrom: "",
          Lotdescto: ""
        }
      },
        () => {
          detailOTDataGrid.current.instance().refresh();
        }
      );
    }
  }
  saveHeaderData(e) {
    if (e != null && e != undefined) {
      e.preventDefault();
      let saveObj = this.state.outgoingGridRecordData;
      if ((!saveObj.rowid) || saveObj.rowid == '00000000-0000-0000-0000-000000000000') {
        axios.post
          (
            `${window._env_.REACT_APP_APIS}/${routes.OwnerShipTransfer.SaveOwnerShipTransfer}`,
            saveObj,
            {
              headers: {
                "Content-Type": "application/json",
                access_token: accessToken,
              },
            }
          )
          .then((res) => {
            if (res.data.success) {
              this.setState(prevState => ({
                outgoingGridRecordData: {
                  ...prevState.outgoingGridRecordData,
                  rowid: res.data.resultdata.rowid,
                  requestid: res.data.resultdata.requestid,
                  status: res.data.resultdata.status,
                  emailid: res.data.resultdata.emailid,
                  identityid: prevState.outgoingGridRecordData.identityid,
                  isDisableSaveBtn: (res.data.resultdata.status == "C" || res.data.resultdata.status == "R" || res.data.resultdata.status == 'Rejected' || res.data.resultdata.status == 'Created') ? false : true
                }
              }));
              notify({
                message: 'Record Saved!',
                width: 100,
              }, 'success', 2000);
            }
            else {
              notify({
                message: 'Couldnt Save Data!!',
                width: 450,
              }, 'error', 2000);
            }
          })
          .catch((err) => {
            notify({
              message: 'Couldnt Save Data!!',
              width: 450,
            }, 'error', 2000);
          });
      }
      else {
        if (saveObj.status == 'Rejected' || saveObj.status == 'Created' || saveObj.status == 'R' || saveObj.status == 'C')
          saveObj.status = 'C';
        axios.post
          (
            `${window._env_.REACT_APP_APIS}/${routes.OwnerShipTransfer.UpdateWMOwershipTransfer}`,
            saveObj,
            {
              headers: {
                "Content-Type": "application/json",
                access_token: accessToken,
              },
            }
          )
          .then((res) => {
            if (res.data.success) {
              this.setState(prevState => ({
                outgoingGridRecordData: {
                  ...prevState.outgoingGridRecordData,
                  rowid: res.data.resultdata.rowid,
                  requestid: res.data.resultdata.requestid,
                  status: res.data.resultdata.status,
                  emailid: res.data.resultdata.emailid,
                  identityid: prevState.outgoingGridRecordData.identityid,
                  isDisableSaveBtn: (res.data.resultdata.status == "C" || res.data.resultdata.status == "R" || res.data.resultdata.status == 'Rejected' || res.data.resultdata.status == 'Created') ? false : true
                }
              }));
              notify({
                message: 'Record Updated!',
                width: 100,
              }, 'success', 2000);
            }
            else {
              notify({
                message: 'Couldnt Save/Update Data!!',
                width: 450,
              }, 'error', 2000);
            }
          })
          .catch((err) => {
            notify({
              message: 'Couldnt Save/Update Data!!',
              width: 450,
            }, 'error', 2000);
          });
      }
    }
  }
  AcceptClick(e) {
    this.UpdateOTStatusAcceptOrReject("A");
  }
  RejectClick(e) {
    this.UpdateOTStatusAcceptOrReject("R");
  }
  ApprovedClick(e) {
    this.setState({ isApprovedClicked: true }, () => {
      this.viewIncomingTransfer();
    });
    //this.UpdateOTStatusAcceptOrReject();
  }
  ApprovedRequest = () => {
    this.UpdateOTStatusAcceptOrReject("P");
  }
  UpdateOTStatusAcceptOrReject(statusOT) {
    this.setState({ loadIndicatorVisible: true });
    let lstRowids = this.state.selectedIncomingGridKeys;
    if (lstRowids.length > 0) {
      let obj = { lstRequestedIds: lstRowids, status: statusOT };
      var that = this;
      axios.post
        (
          `${window._env_.REACT_APP_APIS}/${routes.OwnerShipTransfer.UpdateOTStatusToAccept}`,
          obj,
          {
            headers: {
              "Content-Type": "application/json",
              access_token: accessToken,
            },
          }
        )
        .then((res) => {
          this.setState({ loadIndicatorVisible: false, incomingGridPopupVisible: false });
          if (res.data.success) {
            if (res.data.message)
              alert('Transactions Created. ' + res.data.message, "Success");
            else {
              notify({
                message: 'Record(s) Updated!',
                width: 100,
              }, 'success', 2000);
            }

            incomingGrid.current.instance().refresh().then(() => {
              var keys = that.state.selectedIncomingGridKeys;
              if (keys != null && keys.length > 0) {
                incomingGrid.current.instance().deselectRows(keys);
                incomingGrid.current.instance().selectRows(keys, false);
              }
            });
          }
          else
            alert('Couldnt Update! : ' + res.data.message, "Error");
        })
        .catch((err) => {
          this.setState({ loadIndicatorVisible: false, incomingGridPopupVisible: false });
          notify({
            message: 'Couldnt Update Data!!',
            width: 450,
          }, 'error', 2000);
        });
    } else {
      notify({
        message: 'Please select any data row to update the status.',
        width: 450,
      }, 'error', 2000);
    }
  }
  render() {
    return (
      <div className="row bg-white" >
        <div className="col-md-12 main-page">
          <div id="ot-div">
            <DivLoadPanel
              shadingColor="rgba(0,0,0,0.4)"
              visible={this.state.loadIndicatorVisible}
              showIndicator={true}
              shading={true}
              showPane={true}
              hideOnOutsideClick={false}
              id="ot-loader-indicator"
            />
            <ToolbarHdr className="header">
              <ItemHdr location="before">
                <div className="title">
                  <h6
                    style={{
                      color: window._env_.Color2,
                      marginLeft: '12px'
                    }}
                  >
                    Ownership Transfer
                  </h6>
                </div>
              </ItemHdr>
            </ToolbarHdr>
            <>
              <div className="AccordionItemBody">
                <TabPanel className="TabpanelContainer">
                  {!isAbecasUser ?
                    <TabPanelItem title="Outgoing Transfers">
                      <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
                        remoteOperations={true}
                        ref={outgoingGrid}
                        hoverStateEnabled={true}
                        allowColumnResizing={true}
                        allowColumnReordering={true}
                        onContentReady={this.outgoingGridContentReady}
                        selectedRowKeys={this.state.selectedOutgoingGridKeys}
                        onSelectionChanged={this.outgoingGridselectionChanged}
                        className="GridHeightTabPanel-with-toolbar"
                        showBorders={true}
                      >
                        <Selection mode="multiple" />
                        <ColumnChooser
                          enabled={true}
                          title="Choose Column"
                          width={290}
                          height={290}
                          sortOrder="asc"
                        >
                          <ColumnChooserSearch
                            enabled={true}
                            editorOptions={{ placeholder: 'Search column' }} />
                        </ColumnChooser>
                        <ColumnHeaderFilter />
                        <Export enabled={true} allowExportSelectedData={true} text="Export" />
                        <Sorting visible={true} mode="multiple" />
                        <LoadPanel enabled={true} />
                        <Paging defaultPageSize={100} />
                        <Pager
                          visible={true}
                          showPageSizeSelector={true}
                          allowedPageSizes={[10, 20, 50, 100, 500, 1000, "all"]}
                          showNavigationButtons={true}
                        />
                        <FilterRow visible={true} />
                        <FilterPanel visible={true} />
                        <HeaderFilter visible={false} />
                        <StateStoring
                          enabled={true}
                          type="custom"
                          customLoad={this.outgoingGridLoadState}
                          storageKey={outgoingGridKey}
                          customSave={this.outgoingGridSaveState}
                        />
                        <Column
                          dataField="requestid"
                          caption="Request Id"
                          dataType="string"
                        ></Column>
                        <Column
                          dataField="incomingcustomercodeandname"
                          caption="Customer"
                          dataType="string"
                        ></Column>
                        <Column
                          dataField="statusDescription"
                          caption="Status"
                          dataType="string"
                        ></Column>
                        <Toolbar>
                          <Item location="before">
                            <Button
                              onClick={this.addOutgoingTransfer}
                              text="Add"
                              type="default"
                            />
                          </Item>
                          <Item location="before">
                            <Button
                              onClick={this.editOutgoingTransfer}
                              text="edit"
                              type="default"
                              className="gridTopButton"
                              disabled={
                                !(this.state.selectedOutgoingGridData.length === 1 &&
                                  (this.state.selectedOutgoingGridData[0].status == 'C' || this.state.selectedOutgoingGridData[0].status == 'R'))
                              } />
                          </Item>
                          <Item location="before">
                            <Button
                              onClick={this.deleteOutgoingTransfer}
                              text="Delete"
                              type="default"
                              className="gridTopButton"
                              disabled={!this.state.selectedOutgoingGridKeys.length || this.state.selectedOutgoingGridData.some(item => item.status === 'P')} />
                          </Item>
                          <Item location="after">
                            <GridLayoutManager gridKey={outgoingGridKey} dataGrid={outgoingGrid} setCurrentLayout={this.setCurrentLayout} />
                          </Item>
                          <Item name="exportButton" />
                          <Item name="columnChooserButton" />
                        </Toolbar>
                      </DataGrid>
                      {
                        this.state.addEditOutgoingGridPopupVisible &&
                        <Popup
                          visible={this.state.addEditOutgoingGridPopupVisible}
                          onHiding={this.hideAddEditOutgoingGridPopup}
                          dragEnabled={false}
                          hideOnOutsideClick={true}
                          showCloseButton={true}
                          showTitle={true}
                          title={this.state.outgoingGridPopupTitle}
                          container="#root"
                          closeOnOutsideClick={true}
                          height={"90vh"}
                        >
                          <form onSubmit={(e) => this.saveHeaderData(e)}>
                            <div className="row">
                              <div className="col-md-3 pl-0">
                                <TextBox
                                  id="request-id"
                                  value={this.state.outgoingGridRecordData.requestid}
                                  disabled={true}
                                  stylingMode="outlined"
                                  labelMode="static"
                                  label="Request Id"
                                />
                              </div>
                              <div className="col-md-3 pl-0">
                                <TextBox
                                  id="customer-id"
                                  value={this.state.outgoingGridRecordData.identityid}
                                  onValueChanged={(e) => this.handleFormChange("identityid", e.value)}
                                  stylingMode="outlined"
                                  labelMode="static"
                                  label="Customer"
                                >
                                  <Validator>
                                    <RequiredRule message="Please fill customer." />
                                    <AsyncRule
                                      message="Please enter valid customer code"
                                      validationCallback={this.customerValidation}
                                    />
                                  </Validator>
                                </TextBox>
                              </div>
                              <div className="col-md-3 pl-0">
                                <TextBox
                                  id="status"
                                  value={this.state.outgoingGridRecordData.status}
                                  disabled={true}
                                  stylingMode="outlined"
                                  labelMode="static"
                                  label="Status"
                                />
                              </div>
                              <div className="col-md-3 px-0">
                                <TextBox
                                  id="email-id"
                                  value={this.state.outgoingGridRecordData.emailid}
                                  onValueChanged={(e) => this.handleFormChange("emailid", e.value)}
                                  stylingMode="outlined"
                                  labelMode="static"
                                  label="Email"
                                >
                                  <Validator>
                                    <PatternRule
                                      message="The email id must be in correct format."
                                      pattern={/^[\d\w._-]+@[\d\w._-]+\.[\w]+$/i}
                                    />
                                  </Validator>
                                </TextBox>
                              </div>
                            </div>
                            <div className="w-100 d-flex justify-content-between accordianLastRow mb-2">
                              <div
                                style={{
                                  color: window._env_.Color2,
                                  fontSize: "16px",
                                  fontWeight: "bold",
                                  marginTop: "10px"
                                }}>
                                Transfer Totals: <span className="pl-1 d-inline-block text-secondary">{this.state.detailTransferQuantityCount}</span>
                              </div>
                              <Button
                                text="Save"
                                className="float-right"
                                useSubmitBehavior={true}
                                disabled={this.state.outgoingGridRecordData.isDisableSaveBtn}
                                type="default"
                              ></Button>
                            </div>
                          </form>
                          <div className="row mb-2">
                            <div className="col-md-12 main-page" >
                              <div id="accordion" >
                                <Accordion
                                  dataSource={searchpanel}
                                  collapsible={true}
                                  multiple={false}
                                  animationDuration={300}
                                  selectedItems={this.state.selectedItems}
                                  onSelectionChanged={this.selectionChanged}
                                  itemTitleRender={() => (
                                    <ToolbarHdr className="accordian-toolbar">
                                      <ItemHdr location="before">
                                        <div className="title">
                                          <h6
                                            style={{
                                              color: window._env_.Color2
                                            }}
                                          >
                                            Filter Criteria
                                          </h6>
                                        </div>
                                      </ItemHdr>
                                      <ItemHdr location="after">
                                        <Button className="gridTopButton" onClick={this.SearchGridFilter} type="default" text="Search" />
                                      </ItemHdr>
                                      <ItemHdr location="after">
                                        <Button className="gridTopButton" onClick={this.ResetGridFilter} text="Reset" />
                                      </ItemHdr>
                                    </ToolbarHdr>
                                  )}
                                  itemRender={(itemProps) => (
                                    <div>
                                      <div className="row">
                                        <div className="col-md-3">
                                          <TextBox
                                            label="Item Code From"
                                            value={this.state.OTDetailGridDataFilterCriteria.Itemcodefrom}
                                            onValueChanged={(data) => this.setState({
                                              OTDetailGridDataFilterCriteria:
                                                { ...this.state.OTDetailGridDataFilterCriteria, Itemcodefrom: data.value }
                                            })}
                                            stylingMode='outlined'
                                            labelMode="static"
                                          />
                                        </div>
                                        <div className="col-md-3">
                                          <TextBox
                                            label="Item Code To"
                                            value={this.state.OTDetailGridDataFilterCriteria.Itemcodeto}
                                            onValueChanged={(data) => this.setState({
                                              OTDetailGridDataFilterCriteria:
                                                { ...this.state.OTDetailGridDataFilterCriteria, Itemcodeto: data.value }
                                            })}
                                            stylingMode='outlined'
                                            labelMode="static"
                                          />
                                        </div>
                                        <div className="col-md-3">
                                          <TextBox
                                            label="Lot Code From"
                                            value={this.state.OTDetailGridDataFilterCriteria.Lotcodefrom}
                                            onValueChanged={(data) => this.setState({
                                              OTDetailGridDataFilterCriteria:
                                                { ...this.state.OTDetailGridDataFilterCriteria, Lotcodefrom: data.value }
                                            })}
                                            stylingMode='outlined'
                                            labelMode="static"
                                          />
                                        </div>
                                        <div className="col-md-3">
                                          <TextBox
                                            label="Lot Code To"
                                            value={this.state.OTDetailGridDataFilterCriteria.Lotcodeto}
                                            onValueChanged={(data) => this.setState({
                                              OTDetailGridDataFilterCriteria:
                                                { ...this.state.OTDetailGridDataFilterCriteria, Lotcodeto: data.value }
                                            })}
                                            stylingMode='outlined'
                                            labelMode="static"
                                          />
                                        </div>
                                      </div>
                                      <div className="row accordianLastRow">
                                        <div className="col-md-3">
                                          <TextBox
                                            label="Item Desc From"
                                            value={this.state.OTDetailGridDataFilterCriteria.Itemdescfrom}
                                            onValueChanged={(data) => this.setState({
                                              OTDetailGridDataFilterCriteria:
                                                { ...this.state.OTDetailGridDataFilterCriteria, Itemdescfrom: data.value }
                                            })}
                                            stylingMode='outlined'
                                            labelMode="static"
                                          />
                                        </div>
                                        <div className="col-md-3">
                                          <TextBox
                                            label="Item Desc To"
                                            value={this.state.OTDetailGridDataFilterCriteria.Itemdescto}
                                            onValueChanged={(data) => this.setState({
                                              OTDetailGridDataFilterCriteria:
                                                { ...this.state.OTDetailGridDataFilterCriteria, Itemdescto: data.value }
                                            })}
                                            stylingMode='outlined'
                                            labelMode="static"
                                          />
                                        </div>
                                        <div className="col-md-3">
                                          <TextBox
                                            label="Lot Desc From"
                                            value={this.state.OTDetailGridDataFilterCriteria.Lotdescfrom}
                                            onValueChanged={(data) => this.setState({
                                              OTDetailGridDataFilterCriteria:
                                                { ...this.state.OTDetailGridDataFilterCriteria, Lotdescfrom: data.value }
                                            })}
                                            stylingMode='outlined'
                                            labelMode="static"
                                          />
                                        </div>
                                        <div className="col-md-3">
                                          <TextBox
                                            label="Lot Desc To"
                                            value={this.state.OTDetailGridDataFilterCriteria.Lotdescto}
                                            onValueChanged={(data) => this.setState({
                                              OTDetailGridDataFilterCriteria:
                                                { ...this.state.OTDetailGridDataFilterCriteria, Lotdescto: data.value }
                                            })}
                                            stylingMode='outlined'
                                            labelMode="static"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                  id="accordion-container"
                                />
                              </div>
                            </div>
                          </div>
                          <div className="row">
                            <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
                              remoteOperations={true}
                              ref={detailOTDataGrid}
                              hoverStateEnabled={true}
                              allowColumnResizing={true}
                              allowColumnReordering={true}
                              onRowUpdating={this.DetailGridselectionChanged}
                              onContentReady={this.DetailGridContentReady}
                              className={this.state.searchPanelStatus ? "GridHeightAccordianOpen-tabs-with-fields" : "GridHeightAccordianClose-tabs-with-fields"}
                              showBorders={true}
                              searchEnabled={true}
                            >
                              <ColumnChooser
                                enabled={true}
                                title="Choose Column"
                                width={290}
                                height={290}
                                sortOrder="asc"
                              >
                                <ColumnChooserSearch
                                  enabled={true}
                                  editorOptions={{ placeholder: 'Search column' }} />
                              </ColumnChooser>
                              <ColumnHeaderFilter />
                              <Export enabled={true} allowExportSelectedData={true} text="Export" />
                              <Sorting visible={true} mode="multiple" />
                              <LoadPanel enabled={true} />
                              <Paging defaultPageSize={100} />
                              <Pager
                                visible={true}
                                showPageSizeSelector={true}
                                allowedPageSizes={[10, 20, 50, 100, 500, 1000, "all"]}
                                showNavigationButtons={true}
                              />
                              <FilterRow visible={true} />
                              <FilterPanel visible={true} />
                              <HeaderFilter visible={false} />
                              <Editing mode="cell" allowUpdating={true} refreshMode="repaint" />
                              <GroupPanel visible={true} />
                              <Grouping autoExpandAll={false} />
                              <StateStoring
                                enabled={true}
                                type="custom"
                                customLoad={this.detailGridLoadState}
                                storageKey={detailGridKey}
                                customSave={this.detailGridSaveState}
                              />
                              <Column dataField="isselected" dataType="boolean" caption="">
                              </Column>
                              <Column
                                dataField="quantityorder"
                                dataType="number"
                                caption="Quantity"
                              ></Column>
                              <Column
                                dataField="itemcode"
                                caption="Item"
                                allowEditing={false}
                              ></Column>
                              <Column
                                dataField="itemdescription"
                                caption="Item Description"
                                allowEditing={false}
                              ></Column>
                              <Column dataField="lotcode" caption="Lot" allowEditing={false}></Column>
                              <Column
                                dataField="lotdescription"
                                caption="Lot Description"
                                allowEditing={false}
                              ></Column>
                              <Column
                                dataField="classcode"
                                caption="Class"
                                allowEditing={false}
                                visible={false}
                              ></Column>
                              <Column
                                dataField="palletsizecode"
                                caption="PalletSizeCode"
                                allowEditing={false}
                                visible={false}
                              ></Column>
                              <Column
                                dataField="subclasscode"
                                caption="SubClass"
                                allowEditing={false}
                                visible={false}
                              ></Column>
                              <Column
                                dataField="netavailable"
                                caption="Item Net Avl"
                                allowEditing={false}
                              ></Column>
                              <Column
                                dataField="lotnetavailable"
                                caption="Lot Net Avl"
                                allowEditing={false}
                              ></Column>
                              <Toolbar>
                                <Item location="after">
                                  <GridLayoutManager gridKey={detailGridKey} dataGrid={detailOTDataGrid} setCurrentLayout={this.setCurrentLayout} />
                                </Item>
                                <Item name="exportButton" />
                                <Item name="columnChooserButton" />
                              </Toolbar>
                            </DataGrid>
                          </div>
                        </Popup>
                      }
                    </TabPanelItem>
                    : ""
                  }
                  <TabPanelItem title={`${isAbecasUser ? "Transfers" : "Incoming Transfers"}`}>
                    <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
                      remoteOperations={true}
                      ref={incomingGrid}
                      hoverStateEnabled={true}
                      allowColumnResizing={true}
                      allowColumnReordering={true}
                      onContentReady={this.incomingGridContentReady}
                      selectedRowKeys={this.state.selectedIncomingGridKeys}
                      onSelectionChanged={this.incomingGridselectionChanged}
                      className="GridHeightTabPanel-with-toolbar"
                      showBorders={true}
                    >
                      <Selection mode="multiple" />
                      <ColumnChooser
                        enabled={true}
                        title="Choose Column"
                        width={290}
                        height={290}
                        sortOrder="asc"
                      >
                        <ColumnChooserSearch
                          enabled={true}
                          editorOptions={{ placeholder: 'Search column' }} />
                      </ColumnChooser>
                      <ColumnHeaderFilter />
                      <Export enabled={true} allowExportSelectedData={true} text="Export" />
                      <Sorting visible={true} mode="multiple" />
                      <LoadPanel enabled={true} />
                      <Paging defaultPageSize={100} />
                      <Pager
                        visible={true}
                        showPageSizeSelector={true}
                        allowedPageSizes={[10, 20, 50, 100, 500, 1000, "all"]}
                        showNavigationButtons={true}
                      />
                      <FilterRow visible={true} />
                      <FilterPanel visible={true} />
                      <HeaderFilter visible={false} />
                      <StateStoring
                        enabled={true}
                        type="custom"
                        customLoad={this.incomingGridLoadState}
                        storageKey={incomingGridKey}
                        customSave={this.incomingGridSaveState}
                      />
                      <Column
                        dataField="requestid"
                        caption="Request Id"
                        dataType="string"
                      ></Column>
                      {!isAbecasUser ?
                        <Column
                          dataField="outgoingcustomercodeandname"
                          caption="Customer"
                        dataType="string"
                        ></Column>
                        :
                        <Column
                          dataField="outgoingcustomercodeandname"
                          caption="Outgoing Customer"
                          dataType="string"
                        ></Column>
                      }
                      {isAbecasUser ?
                        <Column
                          dataField="incomingcustomercodeandname"
                          caption="Incoming Customer"
                          dataType="string"
                        ></Column>
                        :
                        <></>
                      }
                      {isAbecasUser ?
                        <Column
                          dataField="receipttransactionno"
                          caption="Receipt Transaction No"
                          dataType="string"
                        ></Column>
                        :
                        <></>
                      }
                      {isAbecasUser ?
                        <Column
                          dataField="shipmenttransactionno"
                          caption="Shipment Transaction No"
                          dataType="string"
                        ></Column>
                        :
                        <></>
                      }
                      <Column
                        dataField="statusDescription"
                        caption="Status"
                        dataType="string"
                      ></Column>
                      <Toolbar>
                        <Item location="before">
                          <Button
                            onClick={this.viewIncomingTransfer}
                            text="View"
                            type="default"
                            disabled={this.state.selectedIncomingGridData.length != 1}
                          />
                        </Item>
                        {!isAbecasUser ?
                          <Item location="before">
                            <Button
                              text="Accept"
                              type="default"
                              className="gridTopButton"
                              onClick={this.AcceptClick}
                              disabled={
                                !(this.state.selectedIncomingGridData.length > 0 &&
                                  this.state.selectedIncomingGridData.every(row => row.status == 'C' || row.status == 'R'))
                              }
                            >
                            </Button>
                          </Item>
                          : ""}
                        {!isAbecasUser ?
                          <Item location="before">
                            <Button
                              text="Reject"
                              type="default"
                              className="gridTopButton"
                              onClick={this.RejectClick}
                              disabled={!(this.state.selectedIncomingGridData.length > 0 &&
                                this.state.selectedIncomingGridData.every(row => row.status == 'C'))}
                            >
                            </Button>
                          </Item>
                          : <Item location="before">
                            <Button
                              text="Approve"
                              type="default"
                              className="gridTopButton"
                              onClick={this.ApprovedClick}
                              disabled={!(this.state.selectedIncomingGridData.length == 1 &&
                                (this.state.selectedIncomingGridData[0].status == 'A'))
                              }
                            />
                          </Item>
                        }
                        <Item location="after">
                          <GridLayoutManager gridKey={incomingGridKey} dataGrid={incomingGrid} setCurrentLayout={this.setCurrentLayout} />
                        </Item>
                        <Item name="exportButton" />
                        <Item name="columnChooserButton" />
                      </Toolbar>
                    </DataGrid>
                  </TabPanelItem>
                </TabPanel>
              </div>
            </>

            {
              this.state.incomingGridPopupVisible &&
              <Popup
                visible={this.state.incomingGridPopupVisible}
                onHiding={this.hideIncomingGridPopup}
                dragEnabled={false}
                hideOnOutsideClick={true}
                showCloseButton={true}
                showTitle={true}
                title={this.state.incomingGridPopupTitle}
                container="#root"
                closeOnOutsideClick={true}
                height={"95vh"}
              >
                <div className="row">
                  <div className="col-md-3 pl-0">
                    <TextBox
                      id="request-id"
                      value={this.state.incomingGridRecordData.requestid}
                      stylingMode="outlined"
                      labelMode="static"
                      label="Request Id"
                      disabled={true}
                    />
                  </div>
                  <div className="col-md-3 pl-0">
                    <TextBox
                      id="outgoing-customer"
                      value={this.state.incomingGridRecordData.outgoingcustomercodeandname}
                      stylingMode="outlined"
                      labelMode="static"
                      label={isAbecasUser ? "Outgoing Customer" : "Customer"}
                      disabled={true}
                    />
                  </div>
                  {isAbecasUser && (
                    <div className="col-md-3 pl-0">
                      <TextBox
                        id="incoming-customer"
                        value={this.state.incomingGridRecordData.incomingcustomercodeandname}
                        stylingMode="outlined"
                        labelMode="static"
                        label="Incoming Customer"
                        disabled={true}
                      />
                    </div>
                  )}
                  <div className={`col-md-3 ${isAbecasUser ? "px-0" : "pl-0"}`}>
                    <TextBox
                      id="status"
                      value={this.state.incomingGridRecordData.status}
                      stylingMode="outlined"
                      labelMode="static"
                      label="Status"
                      disabled={true}
                    />
                  </div>
                  {!isAbecasUser && (
                    <div className={`col-md-3 ${!isAbecasUser ? "px-0" : "pl-0"}`}>
                      <TextBox
                        id="email-id"
                        value={this.state.incomingGridRecordData.emailid}
                        stylingMode="outlined"
                        labelMode="static"
                        label="Email"
                        disabled={true}
                      />
                    </div>)}
                </div>
                {!isAbecasUser && (
                  <div className="row accordianLastRow">
                    <div className="col-md-12 pl-0">
                      &nbsp;
                    </div>
                  </div>)}
                {isAbecasUser && (
                  <div className="row accordianLastRow">
                    <div className="col-md-3 pl-0">
                      <TextBox
                        id="email-id"
                        value={this.state.incomingGridRecordData.emailid}
                        stylingMode="outlined"
                        labelMode="static"
                        label="Email"
                        disabled={true}
                      />
                    </div>
                      <div className="col-md-9 pl-0 pt-3">
                        <Button
                          text="Approve"
                          type="default"
                          onClick={this.ApprovedRequest}
                          disabled={!(this.state.selectedIncomingGridData.length == 1 &&
                            (this.state.selectedIncomingGridData[0].status == 'A'))
                          }
                        />
                      </div>
                  </div>
                )}
                <div className="row pt-2">
                  <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
                    remoteOperations={true}
                    ref={detailInDataGrid}
                    hoverStateEnabled={true}
                    allowColumnResizing={true}
                    allowColumnReordering={true}
                    rowAlternationEnabled={true}
                    onContentReady={this.DetailInGridContentReady}
                    className="GridHeightAccordianOpen"
                    showBorders={true}
                  >
                    <Editing
                      mode="cell"
                      allowUpdating={true}
                      allowAdding={true}
                    />
                    <ColumnChooser
                      enabled={true}
                      title="Choose Column"
                      width={290}
                      height={290}
                      sortOrder="asc"
                    >
                      <ColumnChooserSearch
                        enabled={true}
                        editorOptions={{ placeholder: 'Search column' }} />
                    </ColumnChooser>
                    <ColumnHeaderFilter />
                    <Export enabled={true} allowExportSelectedData={true} text="Export" />
                    <Sorting visible={true} mode="multiple" />
                    <LoadPanel enabled={true} />
                    <Paging defaultPageSize={100} />
                    <Pager
                      visible={true}
                      showPageSizeSelector={true}
                      allowedPageSizes={[10, 20, 50, 100, 500, 1000, "all"]}
                      showNavigationButtons={true}
                    />
                    <FilterRow visible={true} />
                    <FilterPanel visible={true} />
                    <HeaderFilter visible={false} />
                    <GroupPanel visible={true} />
                    <Grouping autoExpandAll={false} />
                    <StateStoring
                      enabled={true}
                      type="custom"
                      customLoad={this.detailInGridLoadState}
                      storageKey={detailInGridKey}
                      customSave={this.detailInGridSaveState}
                    />
                    <Column
                      dataField="rowid"
                      caption="rowid"
                      allowEditing={false}
                      visible={false}
                    ></Column>
                    <Column
                      dataField="quantityorder"
                      dataType="number"
                      caption="Quantity"
                      allowEditing={false}
                    ></Column>
                    <Column
                      dataField="itemcode"
                      caption="Item"
                      allowEditing={false}
                    ></Column>
                    <Column
                      dataField="itemdescription"
                      caption="Item Description"
                      allowEditing={false}
                    ></Column>
                    <Column dataField="lotcode" caption="Lot" allowEditing={false}></Column>
                    <Column
                      dataField="lotdescription"
                      caption="Lot Description"
                      allowEditing={false}
                    ></Column>

                    {this.state.isApprovedClicked && isAbecasUser && (
                      <Column dataField="incomingitemcode" caption="Incoming Item" editCellRender={this.renderItemCell}></Column>
                    )}
                    {!this.state.isApprovedClicked && isAbecasUser && (
                      <Column dataField="incomingitemcode" caption="Incoming Item" allowEditing={false}></Column>
                    )}
                    <Column
                      dataField="classcode"
                      caption="Class"
                      allowEditing={false}
                      visible={false}
                    ></Column>
                    <Column
                      dataField="palletsizecode"
                      caption="PalletSizeCode"
                      allowEditing={false}
                      visible={false}
                    ></Column>
                    <Column
                      dataField="subclasscode"
                      caption="SubClass"
                      allowEditing={false}
                      visible={false}
                    ></Column>
                    {isAbecasUser ?
                      <Column
                        dataField="netavailable"
                        caption="Item Net Avl"
                        allowEditing={false}
                      ></Column>
                      : ""}
                    {isAbecasUser ?
                      <Column
                        dataField="lotnetavailable"
                        caption="Lot Net Avl"
                        allowEditing={false}
                      ></Column>
                      : ""}
                    <Summary>
                      <TotalItem
                        column="quantityorder"
                        summaryType="sum"
                        displayFormat="Transfer Totals: {0}" />
                    </Summary>
                    <Toolbar>
                      <Item location="after">
                        <GridLayoutManager gridKey={detailInGridKey} dataGrid={detailInDataGrid} setCurrentLayout={this.setCurrentLayout} />
                      </Item>
                      <Item name="exportButton" />
                      <Item name="columnChooserButton" />
                    </Toolbar>
                  </DataGrid>
                </div>
              </Popup>
            }
          </div>
        </div>
      </div >
    );
  }

  outgoingGridContentReady(e) {
    if (!e.component._hasLoaded) {
      e.component._hasLoaded = true;
      e.component.option("dataSource", this.outgoingGridDataSource);
    }
  }
  DetailGridContentReady(e) {
    if (!e.component._hasLoaded) {
      e.component._hasLoaded = true;
      e.component.option("dataSource", this.DetailDataGridDataSource);
      this.DetailDataGridDataSource.load().then((data) => {
        const totalQuantity = data.reduce((acc, row) => acc + (row.quantityorder || 0), 0);
        this.setState({ detailTransferQuantityCount: totalQuantity });
      });
    }
  }

  DetailInGridContentReady(e) {
    if (!e.component._hasLoaded) {
      e.component._hasLoaded = true;
      e.component.option("dataSource", this.DetailInDataGridDataSource);
    }
  }

  outgoingGridselectionChanged(data) {
    this.setState({
      selectedOutgoingGridKeys: data.selectedRowKeys,
      selectedOutgoingGridData: data.selectedRowsData
    });
  }

  deleteOutgoingTransfer() {
    var that = this;
    let result = confirm("<i>Are your sure you want to delete selected records?</i>", "Delete");
    result.then((dialogResult) => {
      if (dialogResult) {
        outgoingGrid.current.instance().beginCustomLoading("Deleting");
        axios.post
          (
            `${window._env_.REACT_APP_APIS}/${routes.OwnerShipTransfer.DeleteOwnerShipTransfers}`,
            that.state.selectedOutgoingGridKeys,
            {
              headers: {
                "Content-Type": "application/json",
                access_token: accessToken,
              },
            }
          )
          .then((res) => {
            outgoingGrid.current.instance().endCustomLoading();
            outgoingGrid.current.instance().refresh();
          })
          .catch((err) => {
            outgoingGrid.current.instance().endCustomLoading();
            alert(err, "Error");
          });

      }
    });

  }

  hideAddEditOutgoingGridPopup() {
    this.setState({
      addEditOutgoingGridPopupVisible: false,
      detailTransferQuantityCount: 0,
      outgoingGridRecordData: {
        rowid: '00000000-0000-0000-0000-000000000000',
        requestid: '',
        status: '',
        emailid: '',
        identityid: ''
      },
      OTDetailGridDataFilterCriteria: {
        Itemcodefrom: "",
        Itemcodeto: "",
        Lotcodefrom: "",
        Lotcodeto: "",
        Itemdescfrom: "",
        Itemdescto: "",
        Lotdescfrom: "",
        Lotdescto: ""
      },
      selectedIncomingGridKeys: []
    });
    if (outgoingGrid.current != null)
      outgoingGrid.current.instance().refresh();
    if (incomingGrid.current != null)
      incomingGrid.current.instance().refresh();
  }

  hideIncomingGridPopup() {
    this.setState({
      incomingGridPopupVisible: false,
      incomingGridRecordData: {
        requestid: '',
        identityid: '',
        status: '',
        emailid: '',
        incomingcustomerrowid: '',
      }
    });
  }

  addOutgoingTransfer() {
    this.setState({
      addEditOutgoingGridPopupVisible: true
    });
  }

  viewIncomingTransfer() {
    if (this.state.selectedIncomingGridKeys != null && this.state.selectedIncomingGridKeys.length == 1) {
      var that = this;
      axios.get(
        `${window._env_.REACT_APP_APIS}/${routes.OwnerShipTransfer.GetOwnershipTransfer}?rowid=${this.state.selectedIncomingGridKeys[0]}`,
        {
          headers: {
            "Content-Type": "application/json",
            access_token: accessToken,
            Authorization: `Bearer ${accessToken}`
          }
        }).then((response) => {
          that.setState({
            incomingGridPopupVisible: true,
            incomingGridRecordData: {
              requestid: response.data.resultdata.requestid,
              status: response.data.resultdata.statusDescription,
              emailid: response.data.resultdata.emailid,
              incomingcustomercodeandname: response.data.resultdata.incomingcustomercodeandname,
              outgoingcustomercodeandname: response.data.resultdata.outgoingcustomercodeandname,
              incomingcustomerrowid: response.data.resultdata.incomingcustomerrowid,
            }
          });
        });
    }
  }
  viewOutgoingTransfer() {
    if (this.state.selectedOutgoingGridKeys != null && this.state.selectedOutgoingGridKeys.length == 1) {
      var that = this;
      axios.get(
        `${window._env_.REACT_APP_APIS}/${routes.OwnerShipTransfer.GetOwnershipTransfer}?rowid=${this.state.selectedOutgoingGridKeys[0]}`,
        {
          headers: {
            "Content-Type": "application/json",
            access_token: accessToken,
            Authorization: `Bearer ${accessToken}`
          }
        }).then((response) => {
          that.setState({
            addEditOutgoingGridPopupVisible: true,
            outgoingGridRecordData: {
              rowid: response.data.resultdata.rowid,
              requestid: response.data.resultdata.requestid,
              status: response.data.resultdata.statusDescription,
              emailid: response.data.resultdata.emailid,
              identityid: response.data.resultdata.identityid,
              isDisableSaveBtn: (response.data.resultdata.statusDescription == "Created" || response.data.resultdata.statusDescription == "Rejected") ? false : true
            },
          });
        });
    }
  }
  editOutgoingTransfer() {
    this.viewOutgoingTransfer();
  }

  incomingGridContentReady(e) {
    if (!e.component._hasLoaded) {
      e.component._hasLoaded = true;
      e.component.option("dataSource", this.incomingGridDataSource);
    }
  }

  incomingGridselectionChanged(data) {
    this.setState({
      selectedIncomingGridKeys: data.selectedRowKeys,
      selectedIncomingGridData: data.selectedRowsData
    });
  }

}

function mapStateToProps(state) {
  return {
    ReceiptReducer: state.ReceiptReducer,
    oidc: state.oidc,
  };
}

export default connect(mapStateToProps)(OwnershipTransfer);